<ng-content *ngIf="!(showSkeletonSubject | async)"></ng-content>
<div class="skeleton" *ngIf="showSkeletonSubject | async" [ngClass]="skeletonTypeClass"></div>
